<div class="cc1">
    <div class="cc2">
        <h1 *ngIf="loading() === 0">Bitte warten...!</h1>
        <h1 *ngIf="loading() === 1" style="color: green">OK!</h1>
        <h1 *ngIf="loading() === 2" style="color: red">FEHLER!</h1>
    </div>
</div>
